import { combineReducers } from 'redux';
import {
  notificationsReducer,
  invitationsReducer,
  userReducer,
  globalObjectReducer,
  breadcrumbsReducer,
  summaryReducer,
  imagesReducer,
  compareReducer,
} from '@prometheus/redux';

const rootReducer = combineReducers({
  globalObject: globalObjectReducer,
  notifications: notificationsReducer,
  invitations: invitationsReducer,
  user: userReducer,
  breadcrumbs: breadcrumbsReducer,
  summary: summaryReducer,
  images: imagesReducer,
  compare: compareReducer,
});

export default rootReducer;
